import { Draft, PayloadAction } from '@reduxjs/toolkit'
import { filter, map } from 'lodash'

import { LabelingState } from '@/stores/slices/Labeling/types'
import { initialState } from '@/stores/slices/Labeling/const'

import { LabelingNodeItem, UserShortcut } from '@/api/LabelingNode/types'

export const miscReducers = {
  setClassTagFilter: (state: Draft<LabelingState>, action: PayloadAction<string>) => {
    const classId = action.payload

    if (!state.classTagFilters.includes(classId)) {
      state.classTagFilters = [...state.classTagFilters, classId]
    } else {
      state.classTagFilters = filter(state.classTagFilters, (id) => id !== classId)
    }
  },
  resetClassTagFilter: (state: Draft<LabelingState>) => {
    state.classTagFilters = []
  },
  setHasSelectedForClustering: (state: Draft<LabelingState>, action: PayloadAction<{ selected: boolean, itemIds?: string[] }>) => {
    const { selected, itemIds } = action.payload

    state.hasSelectedForClustering = selected

    if (selected && itemIds) {
      state.originalFiles = map(
        state.originalFiles,
        (item) => (itemIds.includes(item?._id || '')
          ? ({ ...item, isSelectedForClustering: true }) as LabelingNodeItem
          : item)
      )
    }
  },
  updateUserShortcuts: (state: Draft<LabelingState>, action: PayloadAction<UserShortcut[]>) => {
    state.userShortcuts = action.payload
  },
  setHotkeysEnabled: (state: Draft<LabelingState>, action: PayloadAction<boolean>) => {
    state.isHotkeysEnabled = action.payload
  },
  setShowFloatingZoomMenu: (state: Draft<LabelingState>, action: PayloadAction<boolean>) => {
    state.showFloatingZoomMenu = action.payload
  },
  resetCurrentLabeling: () => initialState,
}
